import { render, staticRenderFns } from "./Unapproved.vue?vue&type=template&id=da8c127c&scoped=true&"
import script from "./Unapproved.vue?vue&type=script&lang=js&"
export * from "./Unapproved.vue?vue&type=script&lang=js&"
import style0 from "./Unapproved.vue?vue&type=style&index=0&id=da8c127c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8c127c",
  null
  
)

export default component.exports